import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { GetProblemHeadsetsResponse } from './problemHeadsets.types';

const problemHeadsetsApiPath = 'problem_devices';

export const getProblemHeadsetsAPI = async ({
  query,
}: {
  query?: string;
}): Promise<AxiosResponse<GetProblemHeadsetsResponse & ApiError>> => {
  return instance
    .get<GetProblemHeadsetsResponse>(problemHeadsetsApiPath, {
      params: { query },
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
